import { type FC } from "react";
import { QRCodeSVG } from "qrcode.react";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import * as styles from "./styles.css";

type Props = {
  qrCodeUrl: string;
};

export const PcContent: FC<Props> = ({ qrCodeUrl }) => (
  <div className={styles.wrapper}>
    <div className={styles.imageArea}>
      <QRCodeSVG value={qrCodeUrl} size={180} />
    </div>
    <div className={styles.textArea}>
      <div className={styles.paperAirplane}>
        <LazyLoadImage
          src="/images/user_frontend/special/rejob_awards_2026/img_paper_airplane.svg"
          alt=""
          width={77}
          height={24}
        />
      </div>
      <p className={styles.titleBlock}>
        今すぐストーリーズでシェアしよう
        {/* NOTE: jsx-a11y/accessible-emojiルールにより絵文字のラップが必要 */}
        <span role="img" aria-label="キラキラ">
          ✨
        </span>
        <span className={styles.hashtag}>#リジョブアワード</span>
      </p>
      <p className={styles.description}>
        スマホのカメラを起動し、
        <br />
        QRコードをスキャンしてください
      </p>
    </div>
  </div>
);
